module.exports = __webpack_public_path__ + "img/WT-04_1125.1d53fa08.png";